import React from 'react'
import { Navigate } from 'react-router-dom';
import { useAuthCheck } from '../../hooks/useAuthCheck';

const PublicRoute = ({ children }) => {
    const isAuthenticated = useAuthCheck();
    if (isAuthenticated == null) return null;
    return isAuthenticated ? <Navigate to="/dashboard" /> : children;
}

export default PublicRoute;